import React, { useEffect } from 'react';

type ToastProps = {
    message: string;
    type?: 'error' | 'success' | 'info' | 'warning';
    onClose: () => void;
    durationMs?: number;
};

export default function Toast({ message, type = 'info', onClose, durationMs = 3500 }: ToastProps) {
    useEffect(() => {
        const t = setTimeout(onClose, durationMs);
        return () => clearTimeout(t);
    }, [onClose, durationMs]);

    const color = type === 'error' ? 'bg-red-600' : type === 'success' ? 'bg-green-600' : type === 'warning' ? 'bg-amber-600' : 'bg-gray-800';

    return (
        <div className="fixed top-4 right-4 z-[9999] pointer-events-none">
            <div className={`pointer-events-auto flex items-start gap-3 rounded-lg px-4 py-3 text-white shadow-lg max-w-md ${color}`}>
                <span className="text-sm flex-1">{message}</span>
                <button onClick={onClose} className="ml-2 opacity-80 hover:opacity-100 text-lg leading-none">×</button>
            </div>
        </div>
    );
}
